import { render, staticRenderFns } from "./WinCanWorkOrder.vue?vue&type=template&id=c0f49b2e&scoped=true&"
import script from "./WinCanWorkOrder.vue?vue&type=script&lang=ts&"
export * from "./WinCanWorkOrder.vue?vue&type=script&lang=ts&"
import style0 from "./WinCanWorkOrder.vue?vue&type=style&index=0&id=c0f49b2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f49b2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VSnackbar,VSpacer,VTab,VTabs,VTextField})
